import axios from "axios";
import router from '../../router'
import { Storage } from '@ionic/storage'
import moment from 'moment'
const storage = new Storage()


// 19/03/2019

const state = {
    challenge: null,
    challenges: null,
    selected_stream: null,
    leaderboard: null,
    checklist: [],
    terms_copy: null
}
const mutations = {
    SET_CHALLENGE(state, data) {
        storage.set('challenge', data)
        state.challenge = data
    },
    SET_CHALLENGES(state, data) {
        state.challenges = data
    },
    SET_STREAM(state, data) {
        storage.set('selected_stream', data)
        state.selected_stream = data
    },
    SET_LEADERBOARD(state, data) {
        storage.set('leaderboard', data)
        state.leaderboard = data
    },
    SET_CHECKLIST(state, data) {

        state.checklist = data
    },
    SET_TERMS_COPY(state, data) {
        state.terms_copy = data
    }
}
const actions = {
    async loadChallenge ({commit}) {
        await storage.get('challenge').then(async (val) => {
            if(val) commit('SET_CHALLENGE', val)
        })
        await storage.get('selected_stream').then(async (val) => {
            if(val) commit('SET_STREAM', val)
        })
    },
    selectStream({commit}, value) {
        commit('SET_STREAM', value)
    },
    async setChallenge ({commit, dispatch}, value) {
        commit('SET_CHALLENGE', value)
        dispatch('data/setTargets', {
            points_target: value ? value.points_target : 0,
            weight_target: value ? value.weight_target : 0,
            lbm_target: value ? value.lbm_target : 0,
            body_fat_target: value ? value.body_fat_target : 0,
            vfl_target: value ? value.vfl_target : 0
        }, { root: true })
    },
    async getChallenges ({commit, rootState}) {
        if(rootState.global.offline) return

        commit('global/SET_SYNCING', null, {root: true})
        commit('SET_CHALLENGES', [])
        return
        /*
        return new Promise((resolve, reject) => {
            commit('global/SET_SYNCING', 'Looking for Challenges', {root: true})
            axios.post(rootState.settings.baseUrl + 'challenges', {},
                {
                    provider: 'members',
                    headers: {
                        'Authorization': 'Bearer ' + rootState.auth.token
                    }
                }
            ).then(async response => {
                commit('global/SET_SYNCING', null, {root: true})
                commit('SET_CHALLENGES', response.data.challenges)
                resolve(response)
            }).catch(error => {
                // not know at club
                commit('global/SET_SYNCING', null, {root: true})
                console.error('not know at club')
                reject(error)
                throw error.response
            })
        })

         */
    },
    getLeaderboard({commit, state, rootState}) {
        axios.post(rootState.settings.baseUrl + 'get-leaderboard', {challenge_id: state.challenge.id},
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            }
        ).then(async response => {
            // commit('global/SET_SYNCING', null, { root: true })
            commit('SET_LEADERBOARD', response.data)
        }).catch(error => {
            commit('SET_LEADERBOARD', null)
            // not know at club
            console.error(error.response)
            throw error.response
        })
    },
    getChecklist({commit, state, rootState}) {
        axios.post(rootState.settings.baseUrl + 'get-checklist', {challenge_id: state.challenge.id},
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            }
        ).then(async response => {
            commit('SET_CHECKLIST', response.data)
        }).catch(error => {
            console.error(error.response)
            throw error.response
        })
    },
    updateChecklistItem({commit, rootState}, item) {
        axios.post(rootState.settings.baseUrl + 'update-checklist-item', {item},
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            }
        ).then(async response => {

        }).catch(error => {
            console.error(error.response)
            throw error.response
        })
    },
    selectChallenge({commit, rootState, dispatch}, value) {
        if(rootState.global.offline) return
        commit('global/SET_SYNCING', 'Setting the Challenge', { root: true })
        axios.post(rootState.settings.baseUrl + 'select-challenge', {challenge_id: value},
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            }
        ).then(async response => {
            // commit('global/SET_SYNCING', null, { root: true })
            await dispatch('auth/setUser', {}, { root: true })
            router.push('/')
        }).catch(error => {
            // not know at club
            commit('global/SET_SYNCING', null, { root: true })
            console.error('can\'t')
            throw error.response
        })
    },
    resetTerms ({commit, state}) {
        let challenge = Object.assign({}, state.challenge)
        challenge.agree_terms = 0
        commit('SET_CHALLENGE', challenge)
        router.push('/tsandcs')
    },
    decideTerms ({commit, state, rootState, dispatch}, value) {

        axios.post(rootState.settings.baseUrl + 'decide-terms', {challenge_id: state.challenge.id, agree_terms: value},
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            }
        ).then(async (response) => {
            let challenge = Object.assign({}, state.challenge)
            challenge.agree_terms = value
            commit('SET_CHALLENGE', challenge)
            if(parseInt(response.data) < 3) {
                router.push('/')
            } else {
                dispatch('auth/logout', null, {root: true})
            }
        }).catch(error => {
            throw error.response
        })
    },
    getTerms ({commit, state, rootState}) {

        axios.post(rootState.settings.baseUrl + 'challenge-terms', {challenge_id: state.challenge.id},
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            }
        ).then(async response => {
            commit('SET_TERMS_COPY', response.data)
        }).catch(error => {
            throw error.response
        })
    }
}

const getters = {
    weeks (state) {
        if(!state.challenge) return 0
        var start = moment(state.challenge.start_date, 'DD/MM/YYYY')
        var end = moment(state.challenge.end_date, 'DD/MM/YYYY').add(1, 'days')
        return end.diff(start, 'week')
    },
    currentWeek (state, getters) {
        if(!state.challenge) return 0
        var start = moment(state.challenge.start_date, 'DD/MM/YYYY')
        var end = moment()
        return Math.max(1, Math.min(end.diff(start, 'week') + 1, getters.weeks))
    },
    realWeek (state) {
        if(!state.challenge) return 0
        var start = moment(state.challenge.start_date, 'DD/MM/YYYY')
        var end = moment()
        return end.diff(start, 'week') + 1
    },
    currentDay (state, getters) {
        if(!state.challenge) return 0
        var start = moment(state.challenge.start_date, 'DD/MM/YYYY')
        var end = moment()
        return Math.min(end.diff(start, 'day'), (getters.weeks) * 7)
    },
    realDay (state) {
        if(!state.challenge) return 0
        var start = moment(state.challenge.start_date, 'DD/MM/YYYY')
        var end = moment().startOf('day')
        return end.diff(start, 'day')
    },
    cutoffDays (state) {
        if(!state.challenge) return 0
        var start = state.challenge.cutoff_date ? moment(state.challenge.cutoff_date, 'DD/MM/YYYY') : moment(state.challenge.end_date, 'DD/MM/YYYY')
        var end = moment()
        return start.diff(end, 'day') + 1
    },
    agreeTerms (state) {
        if(!state.challenge) return -1
        return parseInt(state.challenge.agree_terms)
    },
    termsCopy (state) {
        if(!state.terms_copy) return null
        return state.terms_copy
    }
}

export default {
  namespaced: true, state, mutations, actions, getters
}
